(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slider-testimonial"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.slider').slick({
    dots: true,
    arrows: false, // Set arrows to false to disable navigation arrows
    infinite: true,
    autoplay: true, 
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();
})();
